module.exports = __webpack_public_path__ + "static/media/openMenu.92c75747.svg";